import {
  FaArrowRightArrowLeft,
  FaAward,
  FaBolt,
  FaBoxesStacked,
  FaBuilding,
  FaCar,
  FaChartLine,
  FaClipboardCheck,
  FaComments,
  FaDiagramProject,
  FaGlobe,
  FaHandshake,
  FaIndustry,
  FaMagnifyingGlassChart,
  FaMedal,
  FaRoute,
  FaShieldHalved,
  FaShip,
  FaSolarPanel,
  FaTruckFast,
  FaUsersGear,
  FaWrench,
} from 'react-icons/fa6'

export const servicesHero = {
  eyebrow: 'Our Services',
  titleLine1: 'Global Metal',
  titleAccent: 'Trading & Supply ',
  titleLine2: 'Chain Solutions',
  description:
    'Delivering reliable sourcing, procurement, logistics, and international trade services for metals and industrial materials worldwide.',
  primaryCta: { label: 'Request Quote', to: '/contact#quote-form' },
  secondaryCta: { label: 'Send Inquiry', to: '/contact#inquiry-form' },
}

export const servicesPageServices = [
  {
    id: 'international-trading',
    title: 'International Metal Trading',
    description:
      'We specialize in structured international trading activities involving non-ferrous metals and industrial materials. Through strong supplier relationships and market expertise, we facilitate smooth cross-border trade operations and dependable material supply worldwide.',
    features: [
      'Global Trade Operations',
      'Cross-Border Transactions',
      'International Supply Network',
      'Market Intelligence',
    ],
    icon: FaGlobe,
  },
  {
    id: 'sourcing-procurement',
    title: 'Global Sourcing & Procurement',
    description:
      'Our expert procurement team identifies reliable suppliers and secures high-quality materials at competitive prices while maintaining international quality standards.',
    features: [
      'Verified Suppliers',
      'Strategic Procurement',
      'Competitive Pricing',
      'Quality Material Sourcing',
    ],
    icon: FaMagnifyingGlassChart,
  },
  {
    id: 'supply-chain',
    title: 'Supply Chain Management',
    description:
      'We manage end-to-end supply chain operations to ensure smooth movement of materials from sourcing locations to final destinations with maximum efficiency.',
    features: [
      'End-to-End Management',
      'Inventory Planning',
      'Logistics Coordination',
      'Risk Management',
    ],
    icon: FaDiagramProject,
  },
  {
    id: 'import-export',
    title: 'Import & Export Operations',
    description:
      'We provide professional import and export solutions supported by proper documentation, compliance management, customs coordination, and trade regulations.',
    features: [
      'Customs Documentation',
      'Trade Compliance',
      'International Shipping',
      'Regulatory Support',
    ],
    icon: FaShip,
  },
  {
    id: 'logistics',
    title: 'Logistics Coordination',
    description:
      'Leveraging strong logistics partnerships and global trade infrastructure, we ensure efficient transportation and timely delivery across international markets.',
    features: [
      'Freight Management',
      'Transportation Planning',
      'Delivery Tracking',
      'Global Logistics Network',
    ],
    icon: FaTruckFast,
  },
  {
    id: 'quality-assurance',
    title: 'Quality Assurance & Inspection',
    description:
      'Strict quality control procedures ensure material consistency, reliability, and compliance with customer specifications before shipment and delivery.',
    features: [
      'Material Inspection',
      'Quality Verification',
      'Consistency Standards',
      'Compliance Monitoring',
    ],
    icon: FaClipboardCheck,
  },
  {
    id: 'vendor-management',
    title: 'Vendor Management',
    description:
      'We maintain long-term strategic relationships with trusted suppliers to ensure uninterrupted material availability and dependable sourcing capabilities.',
    features: [
      'Supplier Evaluation',
      'Vendor Development',
      'Strategic Partnerships',
      'Reliable Supply Base',
    ],
    icon: FaHandshake,
  },
]

export const servicesGlobalTrading = {
  eyebrow: 'Global Reach',
  titleLine1: 'Connecting',
  titleAccent: 'Global Markets',
  titleLine2: 'Through Reliable Trade',
  description:
    "Leveraging Dubai's strategic position as an international trade hub and strong global supplier networks, Torbit Metals Private Limited facilitates seamless trade across Asia, GCC countries, Africa, and international markets. Our expertise enables efficient sourcing, optimized supply chains, and dependable execution.",
  highlights: ['Asia', 'GCC', 'Africa', 'International Markets', 'Strategic Trade Routes'],
}

export const servicesProcessSection = {
  eyebrow: 'Work Process',
  titleLine1: 'How We',
  titleAccent: 'Execute Every',
  titleLine2: 'Engagement',
  description:
    'A disciplined four-step workflow from requirement analysis through delivery and continuous improvement.',
}

export const servicesWorkProcess = [
  {
    step: '01',
    title: 'Understanding Client Requirements & Material Specifications',
    description:
      'Detailed analysis of customer requirements and technical specifications.',
  },
  {
    step: '02',
    title: 'Strategic Sourcing & Procurement',
    description: 'Selection of trusted suppliers and procurement planning.',
  },
  {
    step: '03',
    title: 'Quality Control & Processing',
    description: 'Material inspection, quality verification, and processing activities.',
  },
  {
    step: '04',
    title: 'Delivery & Continuous Improvement',
    description: 'Timely delivery, customer feedback, and ongoing operational enhancement.',
  },
]

export const servicesWhyChoose = [
  {
    title: 'Reliable Supply with Professional Execution',
    text: 'Structured trade execution with dependable material availability and responsive coordination.',
    icon: FaShieldHalved,
  },
  {
    title: 'Practical & Result-Oriented Business Approach',
    text: 'Commercial decisions focused on efficiency, clarity and measurable outcomes for clients.',
    icon: FaChartLine,
  },
  {
    title: 'Dedicated Client Satisfaction',
    text: 'Long-term partnerships built on transparency, communication and consistent support.',
    icon: FaHandshake,
  },
  {
    title: 'Consistent Quality & Reliable Performance',
    text: 'Quality verification and disciplined processes across sourcing, handling and delivery.',
    icon: FaMedal,
  },
]

export const servicesStrengthsSection = {
  eyebrow: 'Our Strengths',
  titleLine1: 'Company',
  titleAccent: 'Strengths',
  description:
    'Core capabilities that support reliable sourcing, quality control and international trade execution.',
}

export const servicesStrengths = [
  { title: 'Expert Sourcing Team', icon: FaMagnifyingGlassChart },
  { title: 'Strong Market Knowledge', icon: FaChartLine },
  { title: 'Skilled Manufacturing Professionals', icon: FaUsersGear },
  { title: 'Strict Quality Control', icon: FaClipboardCheck },
  { title: 'Consistent Material Standards', icon: FaMedal },
  { title: 'Reliable Supply Network', icon: FaBoxesStacked },
  { title: 'Transparent Communication', icon: FaComments },
  { title: 'Competitive Pricing', icon: FaAward },
  { title: 'Reliable Supply Chain', icon: FaRoute },
  { title: 'Timely Delivery', icon: FaTruckFast },
  { title: 'Global Trade Capability', icon: FaGlobe },
  { title: 'Customized Solutions', icon: FaWrench },
]

export const servicesIndustriesSection = {
  eyebrow: 'Industries',
  titleLine1: 'Industries ',
  titleAccent: 'We Serve',
  description:
    'Supporting manufacturers, traders and industrial operators across diverse sectors worldwide.',
}

export const servicesIndustries = [
  { name: 'Manufacturing', icon: FaIndustry },
  { name: 'Construction', icon: FaBuilding },
  { name: 'Engineering', icon: FaWrench },
  { name: 'Infrastructure', icon: FaRoute },
  { name: 'Automotive', icon: FaCar },
  { name: 'Renewable Energy', icon: FaSolarPanel },
  { name: 'Electrical Industry', icon: FaBolt },
  { name: 'Industrial Processing', icon: FaBoxesStacked },
  { name: 'Metal Fabrication', icon: FaArrowRightArrowLeft },
  { name: 'Global Trading Companies', icon: FaGlobe },
]

export const servicesCta = {
  title: 'Looking for a Reliable Metal Trading Partner?',
  description:
    'Partner with Torbit Metals Private Limited for trusted sourcing, professional execution, competitive pricing, and global trade expertise.',
  primaryCta: { label: 'Request Quote', to: '/contact#quote-form' },
  secondaryCta: { label: 'Send Inquiry', to: '/contact#inquiry-form' },
}
